import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'tf-number-display',
  standalone: true,
  template: `<span>{{ value() != null ? value() : '—' }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberDisplayComponent {
  readonly value = input<unknown>();
}
